import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecommendations } from '../api/recommendationAPI';
import './RecommendationsSection.css';
import useSectionInView from '../useSectionInView';
import '../sectionAnimations.css';

export default function RecommendationsSection() {
  const [ref, visible] = useSectionInView();
  const [recommendations, setRecommendations] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [slideDirection, setSlideDirection] = useState('none');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRecs = async () => {
      try {
        const data = await getRecommendations();
        if (Array.isArray(data) && data.length > 0) {
          setRecommendations(data);
        }
      } catch (err) {
        console.warn('Failed to load recommendations:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchRecs();
  }, []);

  // מעבר אוטומטי כל 8 שניות
  useEffect(() => {
    if (recommendations.length === 0) return;
    const interval = setInterval(() => {
      setSlideDirection('left');
      setTimeout(() => {
        setCurrentIndex((i) => (i + 1) % recommendations.length);
        setSlideDirection('none');
      }, 500);
    }, 8000);
    return () => clearInterval(interval);
  }, [recommendations.length]);

  const currentRec = recommendations[currentIndex] || null;
  const prevRec = () => {
    setSlideDirection('right');
    setTimeout(() => {
      setCurrentIndex((i) => (i - 1 + recommendations.length) % recommendations.length);
      setSlideDirection('none');
    }, 500);
  };
  const nextRec = () => {
    setSlideDirection('left');
    setTimeout(() => {
      setCurrentIndex((i) => (i + 1) % recommendations.length);
      setSlideDirection('none');
    }, 500);
  };
  // כפתור ירוק מוביל לדף תוכנית בודדת לפי item_id
  const handleButtonClick = () => {
    if (currentRec?.item_id) navigate(`/item/${currentRec.item_id}`);
  };

  if (loading || !currentRec) {
    return (
      <section ref={ref} className={`rec-section-root section-fade-in${visible ? ' visible' : ''}`}>
        <div className="rec-bg-gif" style={{ backgroundImage: 'url(/home/בעזה-תוכניות.gif)' }}></div>
        <div className="rec-content-box">
          <div className="rec-loading">טוען המלצות...</div>
        </div>
      </section>
    );
  }

  // הצגת תמונה מתוך item_url, שם התוכנית, וטקסט ההמלצה
  const recImage = currentRec.item_url || '';
  const recText = currentRec.text || '';
  const recProgramName = currentRec.item_name || '';
  const recName = currentRec.name || '';

  return (
    <section ref={ref} className={`rec-section-root section-fade-in${visible ? ' visible' : ''}`}>
      <div className="rec-bg-gif" style={{ backgroundImage: 'url(/home/dhort.gif)' }}></div>
      <div className="rec-content-box">
<div className="rec-pink-box">

  {/* שורה ראשית */}
  <div className="rec-main-row">

    <button
      className="rec-arrow rec-arrow-inline"
      onClick={prevRec}
      aria-label="המלצה קודמת"
    >
      &lt;
    </button>

    <div className="rec-slide-wrapper" data-slide={slideDirection}>
      <div className="rec-text-side">
        {recName && <div className="rec-program-title">{recName}</div>}
        <div className="rec-text-content">{recText}</div>
      </div>

      <div className="rec-image-side">
        {recImage ? (
          <>
            <img src={recImage} alt={recProgramName} className="rec-program-img" />
            <div className="rec-image-pink-bar"></div>
          </>
        ) : (
          <div className="rec-placeholder-img">אין תמונה</div>
        )}
      </div>
    </div>

    <button
      className="rec-arrow rec-arrow-inline"
      onClick={nextRec}
      aria-label="המלצה הבאה"
    >
      &gt;
    </button>

  </div>

  {/* כפתור תחתון */}
  <div className="rec-button-wrapper" data-slide={slideDirection}>
    {currentRec.item_id && recProgramName && (
      <button className="rec-action-btn " onClick={handleButtonClick}>
        <span className="rec-btn-arrow">←</span>
        {recProgramName}
      </button>
    )}
  </div>

</div>

      </div>
      <div className="rec-pink-bar-bottom"></div>
    </section>
  );
}



